import React from 'react';
import moment from "moment";
import { formatCurrency } from '../../../../utils/format';
import neoLogo from "../../../../assets/images/Neo_Logo_A.svg";
import { FINANCIAL_TYPES } from '../../../../constants/financial';

class PrintableCashierReport extends React.Component {
    render() {
        const { currentShift, summary, records, tenantName, tenantLogo, user } = this.props;

        const dateStr = moment().format("DD/MM/YYYY");
        const openDate = currentShift?.openedAt ? moment(currentShift.openedAt.toDate()).format("DD/MM/YYYY HH:mm") : "--";
        const closeDate = currentShift?.closedAt ? moment(currentShift.closedAt.toDate()).format("DD/MM/YYYY HH:mm") : "--";
        const statusStr = currentShift?.status === "OPEN" ? "Aberto" : "Fechado";
        
        const consolidatedRecords = [];
        if (records) {
            const groups = {};
            records.forEach(r => {
                if (r.idSale && r.idSale.trim() !== '') {
                    const key = `${r.idSale}_${r.paymentMethod}`;
                    if (!groups[key]) {
                        groups[key] = { ...r, isGrouped: false, groupedCount: 1, totalAmount: r.netAmount || 0 };
                        consolidatedRecords.push(groups[key]);
                    } else {
                        groups[key].totalAmount += (r.netAmount || 0);
                        groups[key].groupedCount += 1;
                        groups[key].isGrouped = true;
                        const descParts = groups[key].description?.split('—') || [];
                        const baseDesc = descParts[0]?.trim() || `Venda ${r.idSale.substring(r.idSale.length - 6)}`;
                        groups[key].description = `${baseDesc} — Parcelado (${groups[key].groupedCount}x)`;
                    }
                } else {
                    consolidatedRecords.push({ ...r, totalAmount: r.netAmount || 0 });
                }
            });
            consolidatedRecords.forEach(item => {
                if (item.isGrouped) {
                    item.netAmount = item.totalAmount;
                }
            });
        }

        const userName = user?.name ? user.name.toUpperCase() : "CAIXA";

        return (
            <div style={{ padding: "30px 40px", fontFamily: "'Inter', 'Helvetica Neue', Helvetica, Arial, sans-serif", color: "#333", backgroundColor: "#fff" }}>
                {/* Cabeçalho */}
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", borderBottom: "2px solid #eee", paddingBottom: "20px", marginBottom: "24px" }}>
                    <div style={{ flex: "0 0 auto", minWidth: "120px" }}>
                        {tenantLogo && (
                            <img src={tenantLogo} alt="Logo" style={{ maxHeight: "70px", maxWidth: "160px", objectFit: "contain" }} />
                        )}
                    </div>
                    <div style={{ textAlign: "right", flex: "1 1 auto", paddingLeft: "15px" }}>
                        <h2 style={{ margin: "0 0 6px 0", fontSize: "14px", fontWeight: "700", color: "#555", textTransform: "uppercase", letterSpacing: "0.5px" }}>
                            {tenantName || "Empresa"}
                        </h2>
                        <h3 style={{ margin: "0 0 4px 0", fontSize: "18px", fontWeight: "700", color: "#111" }}>
                            Relatório de Caixa
                        </h3>
                        <p style={{ margin: "2px 0", fontSize: "13px", color: "#555" }}>
                            <strong>Operador:</strong> {userName}
                        </p>
                    </div>
                </div>

                {/* Info do Turno */}
                <div style={{ marginBottom: "24px", display: "flex", flexWrap: "wrap", gap: "20px", fontSize: "13px" }}>
                    <div><strong>Status:</strong> {statusStr}</div>
                    <div><strong>Abertura:</strong> {openDate}</div>
                    <div><strong>Fechamento:</strong> {closeDate}</div>
                </div>

                {/* Resumo */}
                <div style={{ display: "flex", justifyContent: "space-between", gap: "10px", marginBottom: "24px", backgroundColor: "#f8f9fa", padding: "16px", borderRadius: "6px", border: "1px solid #e9ecef" }}>
                    <div style={{ textAlign: "center", flex: 1 }}>
                        <div style={{ fontSize: "12px", color: "#666" }}>Valor Inicial</div>
                        <div style={{ fontSize: "16px", fontWeight: "bold", color: "#333" }}>{formatCurrency(currentShift?.openingBalance || 0)}</div>
                    </div>
                    <div style={{ textAlign: "center", flex: 1 }}>
                        <div style={{ fontSize: "12px", color: "#666" }}>Recebimentos</div>
                        <div style={{ fontSize: "16px", fontWeight: "bold", color: "#2ecc71" }}>{formatCurrency(summary?.totalIncome || 0)}</div>
                    </div>
                    <div style={{ textAlign: "center", flex: 1 }}>
                        <div style={{ fontSize: "12px", color: "#666" }}>Saídas</div>
                        <div style={{ fontSize: "16px", fontWeight: "bold", color: "#e74c3c" }}>{formatCurrency(summary?.totalExpense || 0)}</div>
                    </div>
                    <div style={{ textAlign: "center", flex: 1 }}>
                        <div style={{ fontSize: "12px", color: "#666" }}>Valor Final</div>
                        <div style={{ fontSize: "16px", fontWeight: "bold", color: "#333" }}>{formatCurrency((currentShift?.openingBalance || 0) + (summary?.balanceOfDay || 0))}</div>
                    </div>
                </div>

                {/* Movimentações */}
                <h4 style={{ fontSize: "15px", fontWeight: "bold", marginBottom: "12px", color: "#444" }}>Movimentações</h4>
                <table style={{ width: "100%", borderCollapse: "collapse", marginBottom: "24px", fontSize: "12px" }}>
                    <thead>
                        <tr style={{ backgroundColor: "#212529", color: "#fff", textAlign: "left" }}>
                            <th style={{ padding: "8px", fontWeight: "600" }}>Pessoa/Entidade</th>
                            <th style={{ padding: "8px", fontWeight: "600" }}>Forma Pgto</th>
                            <th style={{ padding: "8px", fontWeight: "600" }}>Descrição</th>
                            <th style={{ padding: "8px", fontWeight: "600" }}>Tipo</th>
                            <th style={{ padding: "8px", fontWeight: "600", textAlign: "right" }}>Valor</th>
                        </tr>
                    </thead>
                    <tbody>
                        {consolidatedRecords.length === 0 ? (
                            <tr><td colSpan="5" style={{ padding: "12px", textAlign: "center", color: "#888" }}>Nenhuma movimentação.</td></tr>
                        ) : (
                            consolidatedRecords.map((r, idx) => {
                                const isIncome = r.type === FINANCIAL_TYPES.INCOME;
                                return (
                                    <tr key={idx} style={{ borderBottom: "1px solid #dee2e6", backgroundColor: idx % 2 === 0 ? "#fff" : "#f8f9fa" }}>
                                        <td style={{ padding: "8px", color: "#333" }}>{r.entityName || "-"}</td>
                                        <td style={{ padding: "8px", color: "#555" }}>{r.paymentMethod || "Diversos"}</td>
                                        <td style={{ padding: "8px", color: "#555" }}>{r.description || "-"}</td>
                                        <td style={{ padding: "8px", color: isIncome ? "#2ecc71" : "#e74c3c", fontWeight: "600" }}>{isIncome ? "Recebimento" : "Saída"}</td>
                                        <td style={{ padding: "8px", textAlign: "right", color: "#333", fontWeight: "bold" }}>{formatCurrency(r.netAmount || 0)}</td>
                                    </tr>
                                );
                            })
                        )}
                    </tbody>
                </table>

                {/* Assinatura */}
                <div style={{ display: "flex", justifyContent: "flex-end", marginTop: "60px" }}>
                    <div style={{ width: "280px", textAlign: "center" }}>
                        <div style={{ borderTop: "1px solid #333", paddingTop: "8px" }}>
                            <p style={{ margin: 0, fontSize: "12px", color: "#555", fontWeight: "600" }}>Responsável / Operador de Caixa</p>
                        </div>
                    </div>
                </div>

                {/* Rodapé */}
                <div style={{ marginTop: "40px", paddingTop: "20px", borderTop: "2px solid #eee" }}>
                    <div style={{ display: "flex", justifyContent: "flex-end", alignItems: "flex-end" }}>
                        <div style={{ textAlign: "right" }}>
                            <p style={{ margin: "0 0 5px 0", fontSize: "11px", fontStyle: "italic", color: "#999" }}>
                                Gerado em {dateStr} às {moment().format("HH:mm")}.
                            </p>
                            <div style={{ display: "flex", alignItems: "center", justifyContent: "flex-end", gap: "6px", marginTop: "8px" }}>
                                <span style={{ fontSize: "11px", fontWeight: "700", color: "#aaa", letterSpacing: "1px" }}>POWERED BY</span>
                                <img src={neoLogo} alt="NeoApp" style={{ height: "14px", filter: "grayscale(100%) opacity(0.6)" }} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default PrintableCashierReport;
